/**
 * Dynamically load and init a Livewire component
 *
 * @param {*} component
 * @param {*} params
 * @param {*} callback
 */
jQuery.fn.loadLivewireComponent = function (component, params = {}, callback = null) {
    var obj = this;

    axios.get('/ribit/livewire?component=' + component, {params: {params}}).then(response => {
        if (response.status == 200) {
            obj.replaceWith(response.data);

            if (window.livewire) {
                window.livewire.rescan();
            }

            if (callback) {
                callback();
            }
        }
    });
};
